export interface CarouselScrollState {
  canScrollToPrevious: boolean;
  canScrollToNext: boolean;
}

export const NOT_SCROLLABLE: CarouselScrollState = {canScrollToPrevious: false, canScrollToNext: false};

export const getCarouselScrollState = (scroller: HTMLElement): CarouselScrollState => {
  const scrolledDistanceFromStart = Math.abs(scroller.scrollLeft);
  const scrollableDistance = scroller.scrollWidth - scroller.clientWidth;

  return {
    canScrollToPrevious: scrolledDistanceFromStart > 0,
    canScrollToNext: scrolledDistanceFromStart < scrollableDistance,
  };
};
